<template>
  <b-card no-body class="cp__card">
    <b-card-header class="cp__card__header" header-tag="header" role="tab" v-b-toggle="'payment__source__' + paymentSource.id">
      <div class="flex-grow-1">
        <p v-if="heading" class="box__heading">Payment Method</p>
        <div class="d-flex flex-grow-1 align-items-center">
          <img class="left-icon mr-2" :src="require(`@/assets/images/${(getCardIcon(paymentSource.type.toLowerCase()))}.svg`)" alt=""/>
          <p class="cp__card__text mb-0"> **** {{paymentSource.last4}}</p>
          <b-badge class="cp__card__badge" v-if="paymentSource.isDefault">Default</b-badge>
        </div>
      </div>
      <svg class="collapsed-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
        <path d="M1 1L7 7L13 1" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg class="not-collapsed-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
        <path d="M1 7L7 1L13 7" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </b-card-header>
    <b-collapse :id="'payment__source__' + paymentSource.id" accordion="ps-accordion" role="tabpanel">
      <b-card-body class="cp__card__body ps-card-body">
        <div class="d-flex flex-column flex-lg-row">
          <div class="ps__section flex-grow-1">
            <p class="ps__section__heading">Payment Methods</p>
            <p class="ps__number cp__card__text">
              <span>{{paymentSource.type.toUpperCase()}}</span> **** {{paymentSource.last4}}
              <span class="cp__card__badge ml-2 declined" v-if="isDeclined">Declined</span>
              <span class="cp__card__badge ml-2 active" v-else>Active</span>
            </p>
            <p>Expires: {{paymentSource.expDate}}</p>
          </div>
          <div class="ps__section flex-grow-1">
            <p class="ps__section__heading">Billing Address</p>
            <p class="checkout-text">{{session.customer.first_name}} {{session.customer.last_name}}
            </p>
            <p class="checkout-text mt-1">{{session.customer.address1}}</p>
            <p class="checkout-text mt-1" v-if="session.customer.address2">{{session.customer.address2}}</p>
            <p class="checkout-text mt-1">{{session.customer.city}} {{session.customer.state}} {{session.customer.zip}}</p>
            <p class="checkout-text mt-1">{{billingCountry}}</p>
          </div>
        </div>
        <div class="cp__card__actions" v-if="canUpdatePaymentSource">
          <b-button class="btn-outline-success theme-hover" variant="secondary" @click.stop="$emit('update', paymentSource)">
            Edit
          </b-button>
        </div>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import {mapState} from 'vuex'
import {PaymentUpdateAllowed, TranResponse} from '@/constants'

export default {
  name: 'PaymentInfoTile',
  props: {
    paymentSource: Object,
    heading: Boolean
  },
  computed: {
    ...mapState(['session']),
    billingCountry: function() {
      if (this.session && this.session.customer) {
        return this.session.customer.country === 'US' ? 'USA' : this.session.customer.country
      }
      return ''
    },
    isDeclined: function() {
      return this.paymentSource && [TranResponse.HardDecline, TranResponse.SoftDecline].indexOf(this.paymentSource.status) > -1
    },
    canUpdatePaymentSource: function() {
      return this.paymentSource && this.paymentSource.canUpdate !== PaymentUpdateAllowed.NO
    }
  },
  methods: {
    getCardIcon: function(brand) {
      let cardBrandToClass = {
        'jcb': 'jcb',
        'amex': 'amex',
        'visa': 'visa',
        'unknown': 'credit-card',
        'discover': 'discover',
        'diners': 'diners',
        'mastercard': 'mastercard'
      }
      brand = cardBrandToClass[brand] ? brand : 'unknown'
      return cardBrandToClass[brand]
    }
  }
}
</script>

<style scoped>

</style>
